import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { OrdersTripViewComponent } from "../orders-trip-view/orders-trip-view.component";
import { TruckOwnerService } from "../truck-owner.service";
import * as _ from "lodash";
import { EditCreditTripComponent } from "../edit-credit-trip/edit-credit-trip.component";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TruckownerTripCancelComponent } from "../truckowner-trip-cancel/truckowner-trip-cancel.component";
import { MapGeocoder } from "@angular/google-maps";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import * as maplibregl from "maplibre-gl";

declare var $: any;
declare var google: any;

@Component({
  selector: "app-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.css"],
})
export class OrdersComponent implements OnInit {
  Matdialogref!: MatDialogRef<OrdersTripViewComponent>;
  Matdialogre!: MatDialogRef<EditCreditTripComponent>;
  matDialogref: MatDialogRef<TruckownerTripCancelComponent>;

  token: any;
  ordersArray: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  document_array: any = [];
  orderType: any = "-1";
  totalAmntRcd: any;
  amountArray: any = [];
  loading: boolean = false;
  totalItems: number = 0;
  itemsPerPage: number = 10;
  
  order_track: boolean = true;
  isLoading: boolean = false;
  showFullTracking: boolean = false;
  isFullTrackingLoading: boolean = false;
  trackTimerObj: any;
  selTripDetails: any;
  curLoc: any = [];
  trackArray: any = [];
  fullTrackData: any = null;
  data: any;
  startLoc: any = {};
  endLoc: any = {};
  otp: boolean = true;

  map!: maplibregl.Map;
  maplibreMarkers: maplibregl.Marker[] = [];
  routeIntervalId: any;
  currentRoutePoints: any[] = [];
  currentRouteSegments: any[] = [];
  isRouteLoaded = false;
  routeVisible = true;
  mapLoadedPromise: Promise<void> | null = null;
  
  constructor(
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private router: Router,
    private snackBar: MatSnackBar,
    private geocoder: MapGeocoder,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.getOrders(this.orderType);
    let triptype = "orders";
    sessionStorage.setItem("tripType", triptype);
    this.fetch_page = 1;
  }

  calculateAmount(item: any): number {
    const {
      price_per_ton = 0,
      loading_point = 0,
      unloading_point = 0,
    } = item.workOrderOtherDetails || {};
    const workorder_qty = item.workorder_qty || 0;

    if (item.workOrderInfoInfo[0]?.pay_as_load_quantity === "loaded_quantity") {
      return loading_point
        ? price_per_ton * loading_point
        : price_per_ton * workorder_qty;
    } else {
      return unloading_point
        ? price_per_ton * unloading_point
        : price_per_ton * workorder_qty;
    }
  }

  // getAreaAndCity(address: string): string {
  //   if (!address) return "";
  //   const parts = address.split(",");

  //   // Safely retrieve area and city
  //   const area = parts[2]?.trim() || ""; // Use empty string if undefined
  //   const city = parts[3]?.trim() || ""; // Use empty string if undefined

  //   // Combine area and city, avoiding trailing commas
  //   return area && city ? `${area}, ${city}` : area || city;
  // }

  getAddressLine(address: string): string {
    if (!address) return "";

    const parts = address.split(",").map((part) => part.trim()); // Split and trim parts
    const firstPart = parts[0] || ""; // Safely get the first part (e.g., "15-365")
    const secondPart = parts[1] || ""; // Safely get the second part (e.g., "Brindavanam")

    return `${firstPart} ${secondPart}`.trim(); // Combine with a space and trim any extra spaces
  }

  viewTrips(item: any) {
    this.Matdialogref = this.matDialog.open(OrdersTripViewComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
  }
  EditTrips(item: any) {
    this.Matdialogre = this.matDialog.open(EditCreditTripComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
      data: item,
    });
  }
  getOrders(orderType: any) {
    this.loading = true;
    this.services.ordersGet(this.token, orderType, this.startPage).subscribe(
      (response: any) => {
        const allData = response.body.data;
        this.last_page = response.body.meta?.lastPage || 1;
        this.ordersArray = allData;
        let uniqueAmount: any = [];
        this.ordersArray.forEach((item: any) => {
          let totalFare = item.driverRouteInfo?.[0]?.total_fare || 0;
          let isEstimatedPrice = false;
          
          if (item.userInfo?.user_type === 'corporate') {
            totalFare = this.calculateAmount(item);
            
            // Check if we are using the fallback estimated price
            const { loading_point = 0, unloading_point = 0 } = item.workOrderOtherDetails || {};
            if (item.workOrderInfoInfo?.[0]?.pay_as_load_quantity === "loaded_quantity") {
              isEstimatedPrice = !loading_point;
            } else {
              isEstimatedPrice = !unloading_point;
            }
          }

          const s9Payments = item.truckownerPaymentInfo || [];
        
          const totalPaid = s9Payments.reduce((sum: number, payment: any) => {
            return sum + (payment.transaction_amount || 0);
          }, 0);
        
          item.finalFareAfterDeductions = totalFare;
          item.isEstimatedPrice = isEstimatedPrice;
          item.amountPaid = totalPaid;
          item.balanceAmnt = totalFare - totalPaid;
        });        
        this.loading = false;
      },

      (error) => {
        this.loading = false;
        this.ordersArray = [];
        if (error.status == 404) {
          this.last_page = 1;
          return;
        }

        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }


  pagination(action: string) {
    let newPage = this.startPage;
    
    switch(action) {
      case '-1': // Previous page
        newPage = Math.max(1, this.startPage - 1);
        break;
      case '1': // Next page
        newPage = Math.min(this.last_page, this.startPage + 1);
        break;
      case 'first':
        newPage = 1;
        break;
      case 'last':
        newPage = this.last_page;
        break;
      default:
        // If action is a direct page number
        const pageNum = parseInt(action);
        if (!isNaN(pageNum)) {
          newPage = Math.max(1, Math.min(this.last_page, pageNum));
        }
    }
    
    if (newPage !== this.startPage) {
      this.startPage = newPage;
      this.fetch_page = newPage;
      this.getOrders(this.orderType);
    }
  }
  
  getTripsList(selectedTripType: any) {
    this.orderType = selectedTripType;
    if (this.orderType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getOrders(this.orderType);
      this.document_array = [];
    } else if (this.orderType == "liveTrips") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getOrders(this.orderType);
      this.document_array = [];
    } else if (this.orderType == "completed") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getOrders(this.orderType);
      this.document_array = [];
    } else if (this.orderType == "cancelled") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getOrders(this.orderType);
      this.document_array = [];
    }
  }
  cancelTrip(item: any) {
    this.matDialogref = this.matDialog.open(TruckownerTripCancelComponent, {
      data: item,
      autoFocus: false,
    });
  }

  liveTrack(item: any) {
    this.selTripDetails = this.ordersArray.find((trip: any) => trip._id === item);
    this.isLoading = true;
    this.curLoc = [];
    this.order_track = false;
    this.showFullTracking = false;
    this.fullTrackData = null;
    this.isFullTrackingLoading = true;

    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }
    this.stopRoutePolling();

    const fetchLatestLocation = this.services.latestLocation(this.token, item).toPromise();

    const _id = this.selTripDetails?._id;
    let fetchLocationHistory: Promise<any> | null = null;
    if (_id) {
      fetchLocationHistory = this.services.tracking(this.token, _id).toPromise();
    } else {
      this.isFullTrackingLoading = false;
    }

    // Initialize MapLibre map on first track click
    setTimeout(async () => {
      await this.initializeMap();
      
      try {
        const res: any = await fetchLatestLocation;
        this.isLoading = false;
        this.processLocationData(res.body.data);
        if (!this.showFullTracking) {
             this.updateTruckMarker();
        }
      } catch (error) {
         this.isLoading = false;
         this.handleTrackingError(error);
      }

      if (fetchLocationHistory) {
         try {
           const historyRes: any = await fetchLocationHistory;
           let json = historyRes.body ? historyRes.body.data : historyRes;
           const rawPoints = (Array.isArray(json) ? json : (json.truckLocInfo || json.truckLocation || json.data || [])).filter((p: any) => p.latitude && p.longitude);
           if (rawPoints.length > 0) {
             rawPoints.sort((a: any, b: any) => new Date(a.trackDateTime).getTime() - new Date(b.trackDateTime).getTime());
             this.currentRoutePoints = rawPoints;
             this.currentRouteSegments = json.routeSegments || [];
           }
         } catch (e) {
           console.error("Failed to preload location history", e);
         } finally {
           this.isFullTrackingLoading = false;
         }
      }
    }, 100);
  }

  viewFullTracking() {
    this.showFullTracking = true;
    if (this.fullTrackData) {
      this.processLocationData(this.fullTrackData);
    } else {
      this.isLoading = true;
    }

    if (this.trackTimerObj) {
      clearInterval(this.trackTimerObj);
    }
    this.stopRoutePolling();

    const _id = this.selTripDetails?._id;
    if (_id) {
      const vNo = this.trackArray?.truckInfo?.truck_number || this.data?.vehicleNumber || "Truck";
      if (this.currentRoutePoints && this.currentRoutePoints.length > 0) {
        this.processLocationData(this.currentRoutePoints, true);
        this.processAndRenderRoute(vNo, true);
        this.isLoading = false;
      } else {
        this.loadTripRouteHistory(_id, vNo);
        this.isLoading = false;
      }
      this.startRoutePolling(_id, vNo);
    } else {
      this.isLoading = false;
    }
  }

  handleTrackingError(error: any) {
    this.isLoading = false;
    if (
      error?.error?.message === "jwt malformed" ||
      error?.error?.message === "jwt expired"
    ) {
      this.router.navigateByUrl("/");
      window.sessionStorage.clear();
    }
    if (error?.error?.message) {
      this.snackBar.open(error.error.message, "Fail", {
        duration: 5000,
      });
    }
  }

  processLocationData(dataObj: any, isFullTracking = false) {
    if (isFullTracking && this.trackArray) {
      const extractedLocs = dataObj?.truckLocInfo || dataObj?.truckLocation || dataObj?.data || (Array.isArray(dataObj) ? dataObj : undefined);
      this.trackArray.truckLocInfo = extractedLocs;
      this.trackArray.truckLocation = extractedLocs;
    } else {
      this.trackArray = dataObj;
    }
    
    const locArray = this.trackArray?.truckLocInfo || this.trackArray?.truckLocation;
    if (!locArray?.length) return;

    let locations = locArray.flat(Infinity);
    
    this.data = locations[locations.length - 1] || {};
    if (this.trackArray?.endTrackDateTime) {
      this.data.endTrackDateTime = this.trackArray.endTrackDateTime;
    }
    this.otp = this.trackArray.customerCode?.code != null;

    const existingKeys = new Set();
    this.curLoc = locations
      .map((loc: any) => ({
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      }))
      .filter((loc: any) => {
        if (!loc.lat || !loc.lng || isNaN(loc.lat) || isNaN(loc.lng) || loc.lat === 0 || loc.lng === 0) {
          return false;
        }
        const key = `${loc.lat},${loc.lng}`;
        if (existingKeys.has(key)) {
          return false;
        }
        existingKeys.add(key);
        return true;
      });

    this.startLoc = {
      lat: this.trackArray?.pickup_details?.from_lat,
      lng: this.trackArray?.pickup_details?.from_long,
    };
    this.endLoc = {
      lat: this.trackArray?.dropoff_details?.to_lat,
      lng: this.trackArray?.dropoff_details?.to_long,
    };

    if ((!this.data.address || String(this.data.address).toLowerCase() === 'unknown') && this.data.latitude && this.data.longitude) {
      this.geocoder
        .geocode({
          location: {
            lat: Number(this.data.latitude),
            lng: Number(this.data.longitude),
          },
        })
        .subscribe(({ results }) => {
          if (results && results.length) {
            this.data.address = results[0].formatted_address;
          }
        });
    }
  }

  closeTracking() {
    this.order_track = true;
    this.curLoc = { lat: 0, lng: 0 };
    this.clearAllIntervals();
    this.stopRoutePolling();
    
    // Clean up map when closing
    if (this.map) {
      this.maplibreMarkers.forEach(m => m.remove());
      this.maplibreMarkers = [];
      this.map.remove();
      (this as any).map = null;
      this.mapLoadedPromise = null;
    }
  }

  openModal(item: any) {
    $("#myModal").modal("show");
  }

  closeModel() {
    $("#myModal").modal("hide");
  }

  clearAllIntervals() {
    const interval_id = window.setInterval(function () { },
      Number.MAX_SAFE_INTEGER);
    for (let i = 1; i < interval_id; i++) {
      window.clearInterval(i);
    }
  }

  // --- MapLibre OSRM Implementation ---

  async initializeMap() {
    if (this.mapLoadedPromise) return this.mapLoadedPromise;
    
    this.mapLoadedPromise = new Promise(async (resolve) => {
      let styleJson: any;
      try {
        styleJson = await this.http.get("/assets/map-styles/maptiler-streets-local.json").toPromise();
        if (styleJson.sources && styleJson.sources.openmaptiles) {
          styleJson.sources.openmaptiles.url = environment.tile_server_url;
        }
      } catch (e) {
        styleJson = {
          version: 8,
          sources: {},
          layers: [{ id: "bg", type: "background", paint: { "background-color": "#f2ead8" } }],
        };
      }

      this.map = new maplibregl.Map({
        container: "map-container",
        center: [78.9629, 20.5937],
        zoom: 5.11,
        minZoom: 5.11,
        maxZoom: 18.06,
        maxBounds: [[67.67457, 5.896067], [97.41989, 35.730908]],
        style: styleJson,
        transformRequest: (url, resourceType) => {
          if (url.includes(environment.tile_server_url)) {
            return { url: url, headers: { 'X-API-Key': environment.tile_api_key } };
          }
          return { url };
        }
      });

      this.map.addControl(new maplibregl.NavigationControl(), "top-right");
      this.map.addControl(new maplibregl.FullscreenControl(), "top-right");
      
      this.map.on('load', () => {
        resolve();
      });
    });

    return this.mapLoadedPromise;
  }

  updateTruckMarker() {
    if (!this.map || !this.data || !this.data.latitude) return;
    
    const lat = Number(this.data.latitude);
    const lng = Number(this.data.longitude);
    const vNo = this.trackArray?.truckInfo?.truck_number || this.data?.vehicleNumber || "Truck";
    const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 110"><path fill="#f58634" d="M16.0227 5.68833L15.6477 5.44674V6.77548H14.375L14.625 4.77688L14.375 4.61216L20.5796 0.0109854L21.0227 0.351404L16.0227 5.68833ZM28.9659 0.340425L29.4205 0L35.625 4.60118L35.375 4.7659L35.625 6.7645H34.3523V5.43576L33.9773 5.68833L28.9659 0.340425ZM36.8296 61.2429H13.1705V40.3893H36.8296V61.2429ZM37.6364 7.1159C37.6364 7.85165 36.8864 8.45563 35.9546 8.45563H14.7273C13.8068 8.45563 13.0568 7.85165 13.0568 7.1159C13.0568 6.36917 13.8068 5.7652 14.7273 5.7652H35.9546C36.8864 5.7652 37.6364 6.36917 37.6364 7.1159ZM43.6364 28.8699H27.3068H24H6.89775C6.89775 28.8699 7.54547 13.8914 8.62502 12.2222C9.70456 10.5531 13.375 6.87432 15.3182 6.63273C16.7614 6.45703 22.6818 6.54488 25.625 6.59978C28.4545 6.54488 34.1364 6.45703 35.5341 6.63273C37.3978 6.87432 40.9318 10.5531 41.9659 12.2222C43.0114 13.8914 43.6364 28.8699 43.6364 28.8699V28.8699ZM25.2614 19.393L9.55683 18.9538C9.55683 18.9538 15 8.89488 16.4318 8.19208C17.8523 7.47829 25.2614 7.74184 25.2614 7.74184V19.393ZM25.2614 7.74184C25.2614 7.74184 32.6818 7.47829 34.1023 8.19208C35.5227 8.90586 40.9773 18.9538 40.9773 18.9538L25.2614 19.393V7.74184ZM41.1023 28.6283C41.1023 29.419 40.0568 30.0559 38.7728 30.0559H11.7614C10.4659 30.0559 9.43182 29.419 9.43182 28.6283V19.426C9.43182 18.6353 10.4659 17.9984 11.7614 17.9984H38.7728C40.0568 17.9984 41.1023 18.6353 41.1023 19.426V28.6283ZM39.75 29.7814C39.75 30.572 38.7728 31.2089 37.5796 31.2089H12.5C11.3068 31.2089 10.3296 30.572 10.3296 29.7814V20.568C10.3296 19.7884 11.3068 19.1405 12.5 19.1405H37.5796C38.7728 19.1405 39.75 19.7884 39.75 20.568V29.7814ZM43.6364 26.7615V45.5615H6.89775V26.7615H6.9091C7.21591 23.7087 15.3182 21.2599 25.2614 21.2599C35.2159 21.2599 43.3068 23.7087 43.625 26.7615H43.6364ZM12.5796 43.53H9.43182V27.1459C9.70455 24.4884 16.7273 22.347 25.3637 22.347C33.3978 22.347 40.0341 24.2029 41.1364 26.6078C38.2159 25.4328 33.6477 24.6751 28.5114 24.6751C19.875 24.6751 12.8523 26.8054 12.5909 29.4739H12.5796V43.53ZM35.6023 36.5349C35.6023 37.3255 34.5568 37.9625 33.2727 37.9625H20.0568C18.7614 37.9625 17.7159 37.3255 17.7159 36.5349V31.78C17.7159 30.9893 18.7614 30.3524 20.0568 30.3524H33.2727C34.5568 30.3524 35.6023 30.9893 35.6023 31.78V36.5349ZM35.6023 37.1828C35.6023 37.9734 34.5568 38.6104 33.2727 38.6104H20.0568C18.7614 38.6104 17.7159 37.9734 17.7159 37.1828V32.4279C17.7159 31.6372 18.7614 31.0003 20.0568 31.0003H33.2727C34.5568 31.0003 35.6023 31.6372 35.6023 32.4279V37.1828ZM9.51139 20.2606L6.20456 18.5804L0.170455 18.8769L0 18.218L6.53409 18.0423L10.2614 19.2942L9.51139 20.2606ZM39.7387 19.3052L43.4659 18.0423L50 18.218L49.8295 18.8879L43.7955 18.5804L40.4886 20.2606L39.7387 19.3052ZM47.2046 108.375C47.2046 109.275 46.4773 110 45.5796 110H4.39775C3.50002 110 2.77274 109.275 2.77274 108.375V48.7571C2.77274 47.8567 3.50002 47.1319 4.39775 47.1319H45.5796C46.4773 47.1319 47.2046 47.8567 47.2046 48.7571V108.375ZM47.2046 48.7571V108.375C47.2046 109.275 46.4773 110 45.5796 110H37.8409C38.7386 110 39.4659 109.275 39.4659 108.375V48.7571C39.4659 47.8567 38.7386 47.1319 37.8409 47.1319H45.5796C46.4773 47.1319 47.2046 47.8567 47.2046 48.7571ZM13.6591 110H9.14773V47.1319H13.6591V110ZM32.6705 77.3086C32.6705 81.4046 29.2273 84.732 24.9887 84.732C20.75 84.732 17.3182 81.4046 17.3182 77.3086C17.3182 73.2125 20.75 69.8962 24.9887 69.8962C29.2273 69.8962 32.6705 73.2125 32.6705 77.3086ZM31.5 77.3086C31.5 80.7787 28.5796 83.6009 24.9887 83.6009C21.3977 83.6009 18.4887 80.7787 18.4887 77.3086C18.4887 73.8385 21.3977 71.0273 24.9887 71.0273C28.5796 71.0273 31.5 73.8385 31.5 77.3086ZM22.5568 80.2296C22.5568 80.4492 22.3636 80.6359 22.1364 80.6359C21.8977 80.6359 21.7045 80.4492 21.7045 80.2296V74.3326C21.7045 74.102 21.8977 73.9153 22.1364 73.9153C22.3636 73.9153 22.5568 74.102 22.5568 74.3326V80.2296ZM28.2386 80.2296C28.2386 80.4492 28.0455 80.6359 27.8182 80.6359C27.5796 80.6359 27.3977 80.4492 27.3977 80.2296V74.3217C27.3977 74.102 27.5796 73.9153 27.8182 73.9153C28.0455 73.9153 28.2386 74.102 28.2386 74.3217V80.2296Z" stroke="white" stroke-width="0.1" /></svg>`;
    const iconUrl = 'data:image/svg+xml;base64,' + btoa(svgIcon);

    let existingMarker = this.maplibreMarkers.find((m: any) => m.truckNumber === vNo);
    
    if (existingMarker) {
      const startLngLat = existingMarker.getLngLat();
      const start: [number, number] = [startLngLat.lng, startLngLat.lat];
      const end: [number, number] = [lng, lat];
      
      if (start[0] !== end[0] || start[1] !== end[1]) {
        const bearing = this.calculateBearing(start[1], start[0], end[1], end[0]);
        const el = existingMarker.getElement();
        const innerEl = el.querySelector(".marker-icon-inner") as HTMLElement;
        if (innerEl) innerEl.style.transform = `rotate(${bearing}deg)`;
        this.animateMarker(existingMarker, start, end, 2000);
      }
    } else {
      const el = document.createElement("div");
      el.className = "maplibre-marker";
      el.style.width = "32px"; 
      el.style.height = "32px";
      el.style.cursor = "pointer";

      const innerEl = document.createElement("div");
      innerEl.className = "marker-icon-inner";
      innerEl.style.width = "100%";
      innerEl.style.height = "100%";
      innerEl.style.backgroundImage = `url(${iconUrl})`;
      innerEl.style.backgroundSize = "contain";
      innerEl.style.backgroundRepeat = "no-repeat";
      innerEl.style.backgroundPosition = "center";
      innerEl.style.transition = "transform 0.5s ease-in-out";
      
      let initialBearing = this.data.course || 0;
      if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
        const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);
        if (validSegments.length > 0) {
          const lastSeg = validSegments[validSegments.length - 1];
          const p1 = lastSeg[lastSeg.length - 2];
          const p2 = lastSeg[lastSeg.length - 1];
          initialBearing = this.calculateBearing(p1[1], p1[0], p2[1], p2[0]);
        }
      } else if (this.currentRoutePoints && this.currentRoutePoints.length >= 2) {
        const lastIdx = this.currentRoutePoints.length - 1;
        const p1 = this.currentRoutePoints[lastIdx - 1];
        const p2 = this.currentRoutePoints[lastIdx];
        initialBearing = this.calculateBearing(Number(p1.latitude), Number(p1.longitude), Number(p2.latitude), Number(p2.longitude));
      }
      innerEl.style.transform = `rotate(${initialBearing}deg)`;
      el.appendChild(innerEl);

      const m = new maplibregl.Marker({ element: el })
        .setLngLat([lng, lat])
        .addTo(this.map);
        
      (m as any).truckNumber = vNo;
      el.addEventListener("click", () => this.openModal(this.trackArray));
      this.maplibreMarkers.push(m);
    }
    
    if (!this.showFullTracking) {
      this.renderStartEndMarkers();
      if (this.startLoc && this.startLoc.lng && this.endLoc && this.endLoc.lng) {
        const bounds = new maplibregl.LngLatBounds();
        bounds.extend([lng, lat]);
        bounds.extend([Number(this.startLoc.lng), Number(this.startLoc.lat)]);
        bounds.extend([Number(this.endLoc.lng), Number(this.endLoc.lat)]);
        this.map.fitBounds(bounds, { padding: 60, duration: 1000 });
      } else {
        this.map.flyTo({ center: [lng, lat], zoom: 14, duration: 1000 });
      }
    }
  }

  renderStartEndMarkers() {
    if (!this.map) return;
    if (!this.startLoc || !this.startLoc.lng || !this.startLoc.lat || !this.endLoc || !this.endLoc.lng || !this.endLoc.lat) return;

    const startGeoJSON: any = { type: "Feature", geometry: { type: "Point", coordinates: [Number(this.startLoc.lng), Number(this.startLoc.lat)] } };
    const endGeoJSON: any = { type: "Feature", geometry: { type: "Point", coordinates: [Number(this.endLoc.lng), Number(this.endLoc.lat)] } };

    const sourceStart = this.map.getSource("route-start") as maplibregl.GeoJSONSource;
    if (sourceStart) {
      sourceStart.setData(startGeoJSON);
      (this.map.getSource("route-end") as maplibregl.GeoJSONSource).setData(endGeoJSON);
    } else {
      this.map.addSource("route-start", { type: "geojson", data: startGeoJSON });
      this.map.addSource("route-end", { type: "geojson", data: endGeoJSON });

      this.map.addLayer({ id: "route-start-outer", type: "circle", source: "route-start", paint: { "circle-radius": 10, "circle-color": "#fff", "circle-stroke-color": "#ef4444", "circle-stroke-width": 3 } });
      this.map.addLayer({ id: "route-start-inner", type: "circle", source: "route-start", paint: { "circle-radius": 5, "circle-color": "#ef4444" } });
      this.map.addLayer({ id: "route-end-outer", type: "circle", source: "route-end", paint: { "circle-radius": 10, "circle-color": "#fff", "circle-stroke-color": "#22c55e", "circle-stroke-width": 3 } });
      this.map.addLayer({ id: "route-end-inner", type: "circle", source: "route-end", paint: { "circle-radius": 5, "circle-color": "#22c55e" } });
    }
  }

  loadTripRouteHistory(tripId: string, vNo: string) {
    this.services.tracking(this.token, tripId).subscribe(
      (response: any) => {
        let json = response.body ? response.body.data : response;
        const rawPoints = (Array.isArray(json) ? json : (json.truckLocInfo || json.truckLocation || json.data || [])).filter((p: any) => p.latitude && p.longitude);
        if (rawPoints.length === 0) return;
        
        rawPoints.sort((a: any, b: any) => new Date(a.trackDateTime).getTime() - new Date(b.trackDateTime).getTime());
        this.currentRoutePoints = rawPoints;
        this.currentRouteSegments = json.routeSegments || [];
        this.processLocationData(rawPoints, true);
        this.processAndRenderRoute(vNo, true);
      },
      error => console.error("Failed to query location history:", error)
    );
  }

  startRoutePolling(tripId: string, vNo: string) {
    this.stopRoutePolling();
    this.pollTripRouteHistory(tripId, vNo);
    this.routeIntervalId = setInterval(() => {
      this.pollTripRouteHistory(tripId, vNo);
    }, 10000);
  }

  stopRoutePolling() {
    if (this.routeIntervalId) {
      clearInterval(this.routeIntervalId);
      this.routeIntervalId = null;
    }
  }

  pollTripRouteHistory(tripId: string, vNo: string) {
    this.services.tracking(this.token, tripId).subscribe(
      (response: any) => {
        let json = response.body ? response.body.data : response;
        const rawPoints = (Array.isArray(json) ? json : (json.truckLocInfo || json.truckLocation || json.data || [])).filter((p: any) => p.latitude && p.longitude);
        if (rawPoints.length === 0) return;
        
        rawPoints.sort((a: any, b: any) => new Date(a.trackDateTime).getTime() - new Date(b.trackDateTime).getTime());
        const lastPointTime = this.currentRoutePoints.length > 0 
          ? new Date(this.currentRoutePoints[this.currentRoutePoints.length - 1].trackDateTime).getTime() : 0;
        const brandNewPoints = rawPoints.filter((p: any) => new Date(p.trackDateTime).getTime() > lastPointTime);

        if (brandNewPoints.length > 0) {
          this.currentRoutePoints = [...this.currentRoutePoints, ...brandNewPoints];
          this.currentRouteSegments = json.routeSegments || [];
          this.processLocationData(this.currentRoutePoints, true);
          this.processAndRenderRoute(vNo, false);
        }
      },
      error => console.error("Failed to poll location history:", error)
    );
  }

  async processAndRenderRoute(vNo: string, fitBounds: boolean) {
    const rawPoints = this.currentRoutePoints;
    if (!rawPoints || rawPoints.length === 0) return;
    
    await this.initializeMap();
    this.isRouteLoaded = true;
    const solidFeatures: any[] = [];
    const dottedFeatures: any[] = [];

    if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
      const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);

      for (const segCoords of validSegments) {
        solidFeatures.push({ type: "Feature", geometry: { type: "LineString", coordinates: segCoords } });
      }
      for (let i = 0; i < validSegments.length - 1; i++) {
        const from = validSegments[i][validSegments[i].length - 1];
        const to = validSegments[i + 1][0];
        dottedFeatures.push({ type: "Feature", geometry: { type: "LineString", coordinates: [from, to] } });
      }
    } else {
      const GAP_MS = 5 * 60 * 1000;
      let seg = [rawPoints[0]];
      for (let i = 1; i < rawPoints.length; i++) {
        const gap = new Date(rawPoints[i].trackDateTime).getTime() - new Date(rawPoints[i - 1].trackDateTime).getTime();
        if (gap > GAP_MS) {
          if (seg.length > 1) {
            solidFeatures.push({
              type: "Feature",
              geometry: { type: "LineString", coordinates: seg.map(p => [+p.longitude, +p.latitude]) }
            });
          }
          dottedFeatures.push({
            type: "Feature",
            geometry: { type: "LineString", coordinates: [[+rawPoints[i - 1].longitude, +rawPoints[i - 1].latitude], [+rawPoints[i].longitude, +rawPoints[i].latitude]] }
          });
          seg = [rawPoints[i]];
        } else {
          seg.push(rawPoints[i]);
        }
      }
      if (seg.length > 1) {
        solidFeatures.push({
          type: "Feature",
          geometry: { type: "LineString", coordinates: seg.map(p => [+p.longitude, +p.latitude]) }
        });
      }
    }

    const allCoords = rawPoints.map(p => [+p.longitude, +p.latitude]);
    const pointsGeoJSON = {
      type: "FeatureCollection",
      features: rawPoints.map((p: any) => ({
        type: "Feature",
        geometry: { type: "Point", coordinates: [+p.longitude, +p.latitude] },
        properties: { time: new Date(p.trackDateTime).toLocaleTimeString(), speed: parseFloat(p.device_speed || 0).toFixed(1), course: p.course },
      })),
    };

    const startCoord = (this.startLoc && this.startLoc.lng && this.startLoc.lat) ? [Number(this.startLoc.lng), Number(this.startLoc.lat)] : allCoords[0];
    const endCoord = (this.endLoc && this.endLoc.lng && this.endLoc.lat) ? [Number(this.endLoc.lng), Number(this.endLoc.lat)] : allCoords[allCoords.length - 1];

    const startGeoJSON = { type: "Feature", geometry: { type: "Point", coordinates: startCoord } };
    const endGeoJSON = { type: "Feature", geometry: { type: "Point", coordinates: endCoord } };

    if (fitBounds) {
      const latestPoint = rawPoints[rawPoints.length - 1];
      this.data = latestPoint;
      this.updateTruckMarker();
      this.renderRouteLayers(solidFeatures, dottedFeatures, startGeoJSON, endGeoJSON, pointsGeoJSON, allCoords, fitBounds);
    } else {
      const marker = this.maplibreMarkers.find(m => (m as any).truckNumber === vNo);
      if (marker) {
        const allNodes = this.buildFullPathNodes();
        if (allNodes.length > 0) {
          const currentLngLat = marker.getLngLat();
          let startIndex = 0, minDistance = Infinity;
          for (let i = 0; i < allNodes.length; i++) {
            const dist = this.getDistance(currentLngLat.lat, currentLngLat.lng, allNodes[i].coord[1], allNodes[i].coord[0]);
            if (dist < minDistance) { minDistance = dist; startIndex = i; }
          }
          const endIndex = allNodes.length - 1;
          if (startIndex < endIndex) {
            if ((marker as any).animationFrameId) cancelAnimationFrame((marker as any).animationFrameId);
            const segmentDistances: number[] = [], cumulativeDistances: number[] = [];
            let cumulative = 0;
            cumulativeDistances[startIndex] = 0;
            for (let i = startIndex; i < endIndex; i++) {
              const d = this.getDistance(allNodes[i].coord[1], allNodes[i].coord[0], allNodes[i + 1].coord[1], allNodes[i + 1].coord[0]);
              segmentDistances[i] = d; cumulative += d; cumulativeDistances[i + 1] = cumulative;
            }
            const totalDistance = cumulative, duration = 9000, startTime = performance.now();
            const animate = (time: number) => {
              const elapsed = time - startTime, progress = Math.min(elapsed / duration, 1);
              let currentCoord: [number, number], currentBearing = 0, activeIndex = startIndex;
              if (totalDistance === 0) {
                currentCoord = allNodes[endIndex].coord;
                if (endIndex > 0) currentBearing = this.calculateBearing(allNodes[endIndex - 1].coord[1], allNodes[endIndex - 1].coord[0], allNodes[endIndex].coord[1], allNodes[endIndex].coord[0]);
              } else {
                const targetDist = progress * totalDistance;
                let k = startIndex;
                for (let i = startIndex; i < endIndex; i++) {
                  if (targetDist >= cumulativeDistances[i] && targetDist <= cumulativeDistances[i + 1]) { k = i; break; }
                }
                activeIndex = k;
                const segStartDist = cumulativeDistances[k], segLength = cumulativeDistances[k + 1] - cumulativeDistances[k];
                const segProgress = segLength > 0 ? (targetDist - segStartDist) / segLength : 0;
                const pStart = allNodes[k].coord, pEnd = allNodes[k + 1].coord;
                currentCoord = [pStart[0] + (pEnd[0] - pStart[0]) * segProgress, pStart[1] + (pEnd[1] - pStart[1]) * segProgress];
                currentBearing = this.calculateBearing(pStart[1], pStart[0], pEnd[1], pEnd[0]);
              }
              marker.setLngLat(currentCoord);
              const innerEl = marker.getElement().querySelector(".marker-icon-inner") as HTMLElement;
              if (innerEl) innerEl.style.transform = `rotate(${currentBearing}deg)`;
              const { solidFeatures: traversedSolid, dottedFeatures: traversedDotted } = this.getTraversedFeatures(allNodes, activeIndex, currentCoord);
              const sourceSolid = this.map.getSource("route-solid") as maplibregl.GeoJSONSource;
              const sourceDotted = this.map.getSource("route-dotted") as maplibregl.GeoJSONSource;
              if (sourceSolid) sourceSolid.setData({ type: "FeatureCollection", features: traversedSolid });
              if (sourceDotted) sourceDotted.setData({ type: "FeatureCollection", features: traversedDotted });
              if (progress < 1) (marker as any).animationFrameId = requestAnimationFrame(animate);
            };
            (marker as any).animationFrameId = requestAnimationFrame(animate);
          }
        }
      }
    }
  }

  renderRouteLayers(solidFeatures: any[], dottedFeatures: any[], startGeoJSON: any, endGeoJSON: any, pointsGeoJSON: any, allCoords: number[][], fitBounds = true) {
    if (!this.map) return;
    const sourceSolid = this.map.getSource("route-solid") as maplibregl.GeoJSONSource;
    if (sourceSolid) {
      sourceSolid.setData({ type: "FeatureCollection", features: solidFeatures });
      (this.map.getSource("route-dotted") as maplibregl.GeoJSONSource).setData({ type: "FeatureCollection", features: dottedFeatures });
      (this.map.getSource("route-start") as maplibregl.GeoJSONSource).setData(startGeoJSON);
      (this.map.getSource("route-end") as maplibregl.GeoJSONSource).setData(endGeoJSON);
      (this.map.getSource("route-points") as maplibregl.GeoJSONSource).setData(pointsGeoJSON);
      if (fitBounds) {
        const bounds = new maplibregl.LngLatBounds();
        allCoords.forEach((coord) => bounds.extend(coord as [number, number]));
        this.map.fitBounds(bounds, { padding: 60, duration: 1200 });
      }
    } else {
      this.removeRouteLayers();
      this.map.addSource("route-solid", { type: "geojson", data: { type: "FeatureCollection", features: solidFeatures } });
      this.map.addSource("route-dotted", { type: "geojson", data: { type: "FeatureCollection", features: dottedFeatures } });
      this.map.addSource("route-start", { type: "geojson", data: startGeoJSON });
      this.map.addSource("route-end", { type: "geojson", data: endGeoJSON });
      this.map.addSource("route-points", { type: "geojson", data: pointsGeoJSON });

      this.map.addLayer({ id: "route-shadow", type: "line", source: "route-solid", layout: { "line-cap": "round", "line-join": "round" }, paint: { "line-color": "#f97316", "line-width": 12, "line-opacity": 0.25 } });
      this.map.addLayer({ id: "route-line", type: "line", source: "route-solid", layout: { "line-cap": "round", "line-join": "round" }, paint: { "line-color": "#f97316", "line-width": 5 } });
      this.map.addLayer({ id: "route-gap", type: "line", source: "route-dotted", layout: { "line-cap": "round", "line-join": "round" }, paint: { "line-color": "#94a3b8", "line-width": 3, "line-dasharray": [2, 4] } });
      this.map.addLayer({ id: "route-start-outer", type: "circle", source: "route-start", paint: { "circle-radius": 10, "circle-color": "#fff", "circle-stroke-color": "#ef4444", "circle-stroke-width": 3 } });
      this.map.addLayer({ id: "route-start-inner", type: "circle", source: "route-start", paint: { "circle-radius": 5, "circle-color": "#ef4444" } });
      this.map.addLayer({ id: "route-end-outer", type: "circle", source: "route-end", paint: { "circle-radius": 10, "circle-color": "#fff", "circle-stroke-color": "#22c55e", "circle-stroke-width": 3 } });
      this.map.addLayer({ id: "route-end-inner", type: "circle", source: "route-end", paint: { "circle-radius": 5, "circle-color": "#22c55e" } });
      
      if (fitBounds) {
        const bounds = new maplibregl.LngLatBounds();
        allCoords.forEach((coord) => bounds.extend(coord as [number, number]));
        this.map.fitBounds(bounds, { padding: 60, duration: 1200 });
      }
    }
  }

  removeRouteLayers() {
    if (!this.map) return;
    const layers = ["route-shadow", "route-line", "route-gap", "route-start-outer", "route-start-inner", "route-end-outer", "route-end-inner", "route-hit"];
    layers.forEach(layer => { if (this.map.getLayer(layer)) this.map.removeLayer(layer); });
    const sources = ["route-solid", "route-dotted", "route-start", "route-end", "route-points"];
    sources.forEach(source => { if (this.map.getSource(source)) this.map.removeSource(source); });
  }

  buildFullPathNodes(): { coord: [number, number]; isDotted: boolean }[] {
    const nodes: { coord: [number, number]; isDotted: boolean }[] = [];
    if (!this.currentRoutePoints || this.currentRoutePoints.length === 0) return [];
    if (this.currentRouteSegments && this.currentRouteSegments.length > 0) {
      const validSegments = this.currentRouteSegments.filter((seg: any) => seg && seg.length > 1);
      for (let i = 0; i < validSegments.length; i++) {
        const seg = validSegments[i];
        for (let j = 0; j < seg.length; j++) nodes.push({ coord: [seg[j][0], seg[j][1]], isDotted: (j === seg.length - 1 && i !== validSegments.length - 1) });
      }
    } else {
      let currentSeg: any[] = [this.currentRoutePoints[0]];
      const segments: any[][] = [];
      for (let i = 1; i < this.currentRoutePoints.length; i++) {
        if (new Date(this.currentRoutePoints[i].trackDateTime).getTime() - new Date(this.currentRoutePoints[i - 1].trackDateTime).getTime() > 300000) {
          segments.push(currentSeg); currentSeg = [this.currentRoutePoints[i]];
        } else currentSeg.push(this.currentRoutePoints[i]);
      }
      segments.push(currentSeg);
      for (let i = 0; i < segments.length; i++) {
        const seg = segments[i];
        for (let j = 0; j < seg.length; j++) nodes.push({ coord: [+seg[j].longitude, +seg[j].latitude], isDotted: (j === seg.length - 1 && i !== segments.length - 1) });
      }
    }
    return nodes;
  }

  getTraversedFeatures(nodes: any[], activeIndex: number, currentCoord: [number, number]) {
    const solidFeatures: any[] = [], dottedFeatures: any[] = [];
    let currentSeg: [number, number][] = [];
    for (let i = 0; i <= activeIndex; i++) {
      currentSeg.push(nodes[i].coord);
      if (nodes[i].isDotted) {
        if (currentSeg.length > 1) solidFeatures.push({ type: "Feature", geometry: { type: "LineString", coordinates: currentSeg } });
        dottedFeatures.push({ type: "Feature", geometry: { type: "LineString", coordinates: [nodes[i].coord, (i === activeIndex) ? currentCoord : nodes[i + 1].coord] } });
        currentSeg = [];
      }
    }

    if (currentSeg.length > 0) {
      currentSeg.push(currentCoord);
      solidFeatures.push({ type: "Feature", geometry: { type: "LineString", coordinates: currentSeg } });
    }

    return { solidFeatures, dottedFeatures };
  }

  calculateBearing(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const dLon = ((lon2 - lon1) * Math.PI) / 180, lat1Rad = (lat1 * Math.PI) / 180, lat2Rad = (lat2 * Math.PI) / 180;
    const y = Math.sin(dLon) * Math.cos(lat2Rad), x = Math.cos(lat1Rad) * Math.sin(lat2Rad) - Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLon);
    return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
  }

  getDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371, dLat = (lat2 - lat1) * Math.PI / 180, dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  animateMarker(marker: maplibregl.Marker, startCoords: [number, number], endCoords: [number, number], duration = 2000) {
    const startTime = performance.now();
    const animate = (time: number) => {
      const progress = Math.min((time - startTime) / duration, 1);
      marker.setLngLat([startCoords[0] + (endCoords[0] - startCoords[0]) * progress, startCoords[1] + (endCoords[1] - startCoords[1]) * progress]);
      if (progress < 1) (marker as any).animationFrameId = requestAnimationFrame(animate);
    };
    if ((marker as any).animationFrameId) cancelAnimationFrame((marker as any).animationFrameId);
    (marker as any).animationFrameId = requestAnimationFrame(animate);
  }
}
